import React, { Component,useState,useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { Switch, Route, Redirect,HashRouter ,BrowserRouter} from 'react-router-dom';
import Dashboard from './dashboard/Dashboard';
import Dashboard4 from './dashboard/Dashboard4';
import './App.scss';
import AppRoutes from './AppRoutes';
import Navbar from './shared/Navbar';
import Sidebar from './shared/Sidebar';
import Footer from './shared/Footer';
import { withTranslation } from "react-i18next";
import Summary from './components/summary';
import Dashboard3 from './dashboard/dashboard3';

function App() {
  const [width, setWidth] = useState(window.innerWidth);

const handleResize = () => {
  setWidth(window.innerWidth);
};
useEffect(() => {
  window.addEventListener('resize', handleResize);
  
  return () => {
    window.removeEventListener('resize', handleResize);
  };
}, []);

 function openSidebar(){
    if(width<=800){document.body.classList.toggle('mobile-icon-only',true)
         document.body.classList.toggle('sidebar-icon-only',true)
         document.querySelectorAll('.sidebar .nav-item').forEach((el) => {
         el.classList.remove('hover-open');
         })}
 }


    // let navbarComponent = !this.state.isFullPageLayout ? <Navbar/> : '';
    // let sidebarComponent = !this.state.isFullPageLayout ? <Sidebar/> : '';
    return (
      <div className="container-scroller">
        <Sidebar ></Sidebar>
        <div className="container-fluid page-body-wrapper">
         <Navbar ></Navbar>
          <div className="main-panel"  onClick={ () => {
            
            openSidebar()} }>
            <div className="content-wrapper">
            {/* <HashRouter> */}
        <Switch>
        <Route exact path="/" component={ Dashboard } />
          <Route path="/dashboard" component={ Dashboard4}></Route>
          <Route path="/summary" component={Summary}></Route>
          <Route path="/detail" component={Dashboard3}></Route>

        </Switch>
        {/* </HashRouter> */}
            </div>
            
          </div>
        </div>
      </div>
    );
  }

  // function componentDidUpdate(prevProps) {
  //   if (this.props.location !== prevProps.location) {
  //     this.onRouteChanged();
  //   }
  // }

  // function onRouteChanged() {
    
  //   const { i18n } = this.props;
  //   const body = document.querySelector('body');
  //   if(this.props.location.pathname === '/layout/RtlLayout') {
  //     body.classList.add('rtl');
  //     i18n.changeLanguage('ar');
  //   }
  //   else {
  //     body.classList.remove('rtl')
  //     i18n.changeLanguage('en');
  //   }
  //   window.scrollTo(0, 0);
  //   const fullPageLayoutRoutes = ['/user-pages/login-1', '/user-pages/login-2', '/user-pages/register-1', '/user-pages/register-2', '/user-pages/lockscreen', '/error-pages/error-404', '/error-pages/error-500', '/general-pages/landing-page'];
  //   for ( let i = 0; i < fullPageLayoutRoutes.length; i++ ) {
  //     if (this.props.location.pathname === fullPageLayoutRoutes[i]) {
  //       this.setState({
  //         isFullPageLayout: true
  //       })
  //       document.querySelector('.page-body-wrapper').classList.add('full-page-wrapper');
  //       break;
  //     } else {
  //       this.setState({
  //         isFullPageLayout: false
  //       })
  //       document.querySelector('.page-body-wrapper').classList.remove('full-page-wrapper');
  //     }
  //   }
  // }



export default App
